export const WATCHSTOCK_LIST_ATTEMPT = "WATCHSTOCK_LIST_ATTEMPT";
export const WATCHSTOCK_LIST_SUCCESS = "WATCHSTOCK_LIST_SUCCESS";
export const WATCHSTOCK_LIST_FAILED = "WATCHSTOCK_LIST_FAILED";
//////////////////
export const WATCHSTOCK_NEW_SUCCESS = "WATCHSTOCK_NEW_SUCCESS";
export const WATCHSTOCK_NEW_FAILED = "WATCHSTOCK_NEW_FAILED";
///////////////////
export const WATCHSTOCK_REMOVE_SUCCESS = "WATCHSTOCK_REMOVE_SUCCESS";
export const WATCHSTOCK_REMOVE_FAILED = "WATCHSTOCK_REMOVE_FAILED";

export const WATCHSTOCK_SET_ITEM = "WATCHSTOCK_SET_ITEM";
